module.exports = __webpack_public_path__ + "img/logo-light.a1794787.svg";